import api from '../../api/api'

// initial state
const state = {
  status: {
    getResources: null
  },
	resources: []
}

// actions
const actions = {
  getResources ({ commit, state }) {
    commit('setStatus', { getResources: api.status.PENDING })
    return api.getResources().then((response) => {
      commit('setStatus', { getResources: api.status.SUCCESS })
      commit('setResources', response.data)
    }).catch((error) => {
      commit('setStatus', { getResources: api.status.FAILURE })
    })
  },
}

const mutations = {
  setResources (state, resources) {
    state.resources = resources
  },
  setStatus (state, status) {
    Object.assign(state.status, status)
  }
}


export default {
  namespaced: true,
  state,
  actions,
  mutations
}
